import { defineMessages } from 'react-intl'

export const dashboardMessages = defineMessages({
  title: {
    id: 'dashboard.title',
    description: 'Dashboard page title',
    defaultMessage: 'Home Status',
  },
})
